export const nutritionalDiagnosisOptions = [
  "Peso adecuado, grasa y masa magra dentro de parámetros normales.",
  "Peso adecuado, grasa corporal dentro de parámetros normales, bajo desarrollo muscular",
  "Peso adecuado, exceso de grasa corporal y bajo desarrollo muscular",
  "Peso adecuado con óptimo desarrollo muscular y exceso leve de grasa corporal",
  "Sobrepeso a expensas de alto desarrollo muscular",
  "Sobrepeso a expensas de exceso moderado de grasa corporal y de alto desarrollo muscular",
  "Obesidad",
  "Bajo peso",
  "Bajo peso, déficit de masa magra",
  "Desnutrición",
];

export const anthropometryMethodOptions = [
  { value: "yuhasz", label: "Dos componentes - Yuhasz" },
  { value: "durnin_siri", label: "Dos componentes - Durnin + Siri" },
  { value: "rfm", label: "Masa grasa relativa" },
  { value: "sumatoria_pliegues", label: "Sumatoria de pliegues" },
  { value: "cinco_componentes", label: "Cinco componentes - Ross & Kerr" },
];

export const leanMassSourceOptions = [
  { value: "rfm", label: "Masa libre por masa grasa relativa" },
  { value: "durnin_siri", label: "Peso magro por Durnin + Siri" },
  { value: "cinco_componentes", label: "Peso magro por cinco componentes" },
];

export const anthropometryGoalFieldNames = [
  "fuente_masa_libre_grasa",
  "meta_yuhasz_suma_6_pliegues_mm",
  "meta_yuhasz_cambio_muscular_kg",
  "meta_durnin_suma_4_pliegues_mm",
  "meta_durnin_cambio_muscular_kg",
  "meta_rfm_cintura_ideal_cm",
  "meta_5c_suma_pliegues_ideal_mm",
  "meta_5c_objetivo_imo",
];

export const DEFAULT_ANTHROPOMETRY_SECTIONS = [
  "basicas",
  "pliegues",
  "perimetros",
  "longitudes",
  "diametros",
  "otras",
];

export const anthropometrySectionOptions = [
  {
    id: "basicas",
    label: "Medidas básicas",
    description: "Datos generales usados como base de todos los cálculos.",
    fields: [
      { label: "Peso actual kg", name: "peso_kg", type: "number" },
      { label: "Talla cm", name: "talla_cm", type: "number" },
      { label: "Estatura sentado cm", name: "estatura_sentado_cm", type: "number" },
      { label: "Envergadura cm", name: "envergadura_cm", type: "number" },
      { label: "Peso objetivo kg", name: "peso_objetivo_kg", type: "number" },
      { label: "Fuente masa libre de grasa", name: "fuente_masa_libre_grasa", type: "text", options: leanMassSourceOptions },
    ],
  },
  {
    id: "pliegues",
    label: "Pliegues",
    description: "Pliegues cutáneos en milímetros.",
    fields: [
      { label: "Submandibular", name: "pliegue_submandibular_mm", type: "number" },
      { label: "Tríceps", name: "pliegue_triceps_mm", type: "number" },
      { label: "Bíceps", name: "pliegue_biceps_mm", type: "number" },
      { label: "Subescapular", name: "pliegue_subescapular_mm", type: "number" },
      { label: "Cresta ilíaca", name: "pliegue_cresta_iliaca_mm", type: "number" },
      { label: "Supraespinal", name: "pliegue_supraespinal_mm", type: "number" },
      { label: "Abdominal", name: "pliegue_abdominal_mm", type: "number" },
      { label: "Muslo", name: "pliegue_muslo_mm", type: "number" },
      { label: "Pantorrilla", name: "pliegue_pantorrilla_mm", type: "number" },
    ],
  },
  {
    id: "perimetros",
    label: "Perímetros",
    description: "Perímetros corporales en centímetros.",
    fields: [
      { label: "Cefálico", name: "perimetro_cefalico_cm", type: "number" },
      { label: "Cuello", name: "perimetro_cuello_cm", type: "number" },
      { label: "Brazo relajado", name: "perimetro_brazo_relajado_cm", type: "number" },
      { label: "Brazo relajado 2", name: "perimetro_brazo_relajado_2_cm", type: "number" },
      { label: "Brazo tenso", name: "perimetro_brazo_tenso_cm", type: "number" },
      { label: "Antebrazo máximo", name: "perimetro_antebrazo_cm", type: "number" },
      { label: "Muñeca", name: "perimetro_muneca_cm", type: "number" },
      { label: "Tórax", name: "perimetro_torax_cm", type: "number" },
      { label: "Cintura", name: "perimetro_cintura_cm", type: "number" },
      { label: "Abdomen", name: "perimetro_abdomen_cm", type: "number" },
      { label: "Caderas", name: "perimetro_cadera_cm", type: "number" },
      { label: "Muslo superior", name: "perimetro_muslo_superior_cm", type: "number" },
      { label: "Muslo medio", name: "perimetro_muslo_medio_cm", type: "number" },
      { label: "Pantorrilla", name: "perimetro_pantorrilla_cm", type: "number" },
      { label: "Tobillo", name: "perimetro_tobillo_cm", type: "number" },
    ],
  },
  {
    id: "longitudes",
    label: "Longitudes",
    description: "Longitudes segmentarias en centímetros.",
    fields: [
      { label: "Acromiale-Radiale", name: "longitud_acromiale_radiale_cm", type: "number" },
      { label: "Radiale-Stylion", name: "longitud_radiale_stylion_cm", type: "number" },
      { label: "Stylion Medio-Dactylion", name: "longitud_stylion_medio_dactylion_cm", type: "number" },
      { label: "Ilioespinale", name: "longitud_ilioespinale_cm", type: "number" },
      { label: "Trochanterion", name: "longitud_trochanterion_cm", type: "number" },
      { label: "Trochanterion-Tibiale laterale", name: "longitud_trochanterion_tibiale_laterale_cm", type: "number" },
      { label: "Tibiale laterale", name: "longitud_tibiale_laterale_cm", type: "number" },
      { label: "Pie", name: "longitud_pie_cm", type: "number" },
      { label: "Tibiale mediale-Sphyrion tibiale", name: "longitud_tibiale_mediale_sphyrion_tibiale_cm", type: "number" },
    ],
  },
  {
    id: "diametros",
    label: "Diámetros",
    description: "Diámetros óseos y corporales en centímetros.",
    fields: [
      { label: "Biacromial", name: "diametro_biacromial_cm", type: "number" },
      { label: "Bicristal", name: "diametro_biliocrestal_cm", type: "number" },
      { label: "Bitrocantéreo", name: "diametro_bitrocantereo_cm", type: "number" },
      { label: "Transversal tórax", name: "diametro_torax_transverso_cm", type: "number" },
      { label: "AP tórax", name: "diametro_torax_ap_cm", type: "number" },
      { label: "Biestiloideo", name: "diametro_biestiloideo_cm", type: "number" },
      { label: "Húmero", name: "diametro_humero_cm", type: "number" },
      { label: "Fémur", name: "diametro_femur_cm", type: "number" },
      { label: "Bimaleolar", name: "diametro_bimaleolar_cm", type: "number" },
      { label: "Pie", name: "diametro_pie_cm", type: "number" },
      { label: "AP abdomen", name: "diametro_abdomen_ap_cm", type: "number" },
    ],
  },
  {
    id: "otras",
    label: "Otras medidas",
    description: "Medidas alternativas o de respaldo.",
    fields: [
      { label: "Media envergadura", name: "media_envergadura_cm", type: "number" },
      { label: "Semi brazada", name: "semi_brazada_cm", type: "number" },
      { label: "Antebrazo", name: "longitud_antebrazo_cm", type: "number" },
      { label: "Rodilla-maleolo", name: "rodilla_maleolo_cm", type: "number" },
      { label: "Rodilla-talón", name: "rodilla_talon_cm", type: "number" },
    ],
  },
];

export const anthropometryInputFields = new Set([
  "fecha_nacimiento",
  "fecha_evaluacion",
  "metodo_antropometria",
  "numero_valoracion",
  "etapa_entrenamiento",
  "antropometria_secciones_activas",
  ...anthropometryGoalFieldNames,
  ...anthropometrySectionOptions.flatMap((section) => section.fields.map((field) => field.name)),
]);

const fieldSectionByName = new Map(
  anthropometrySectionOptions.flatMap((section) => section.fields.map((field) => [field.name, section.id])),
);

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function positiveNumber(value) {
  const parsed = toNumber(value);
  return parsed > 0 ? parsed : 0;
}

function round(value, decimals = 1) {
  if (!Number.isFinite(value)) return 0;
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

function parseDateOnly(value) {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }
  const text = String(value).trim();
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    return new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
  }
  const parsed = new Date(text);
  return Number.isNaN(parsed.getTime()) ? null : new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
}

export function calculateAgeYears(fechaNacimiento, fechaReferencia = new Date()) {
  const birth = parseDateOnly(fechaNacimiento);
  const reference = parseDateOnly(fechaReferencia) || parseDateOnly(new Date());
  if (!birth || !reference || birth > reference) return 0;
  const millisecondsPerYear = 365.25 * 24 * 60 * 60 * 1000;
  return round((reference.getTime() - birth.getTime()) / millisecondsPerYear, 1);
}

export function resolvePatientAge(patient, fechaReferencia = new Date()) {
  const calculated = calculateAgeYears(patient?.fecha_nacimiento, patient?.fecha_evaluacion || fechaReferencia);
  return calculated || positiveNumber(patient?.edad);
}

export function normalizeAnthropometrySections(value) {
  const allowed = new Set(DEFAULT_ANTHROPOMETRY_SECTIONS);
  let selected = [];
  if (Array.isArray(value)) {
    selected = value;
  } else if (value && typeof value === "object") {
    selected = Object.entries(value).filter(([, isActive]) => isActive).map(([id]) => id);
  } else if (typeof value === "string") {
    selected = value.split(/[;,|]/);
  }
  const normalized = [...new Set(selected.map((item) => String(item ?? "").trim()).filter((item) => allowed.has(item)))];
  return normalized.length ? normalized : [...DEFAULT_ANTHROPOMETRY_SECTIONS];
}

export function getActiveAnthropometrySections(patient) {
  return normalizeAnthropometrySections(patient?.antropometria_secciones_activas);
}

export function isAnthropometrySectionActive(patient, sectionId) {
  return getActiveAnthropometrySections(patient).includes(sectionId);
}

function patientNumber(patient, fieldName) {
  const sectionId = fieldSectionByName.get(fieldName);
  if (sectionId && !isAnthropometrySectionActive(patient, sectionId)) return 0;
  return positiveNumber(patient?.[fieldName]);
}

function sexIsMale(patient) {
  const value = String(patient?.sexo ?? "").trim().toLowerCase();
  return value === "masculino" || value === "m" || value === "male" || value === "hombre";
}

function fatMassFromPercent(weight, percent) {
  if (!weight || !percent) return null;
  const fatKg = round((percent * weight) / 100, 2);
  return {
    fatKg,
    leanKg: round(weight - fatKg, 2),
  };
}

function listMissing(patient, fieldNames) {
  return fieldNames.filter((fieldName) => !patientNumber(patient, fieldName));
}

function calculateSkinfoldSums(patient) {
  const skinfolds = {
    submandibular: patientNumber(patient, "pliegue_submandibular_mm"),
    triceps: patientNumber(patient, "pliegue_triceps_mm"),
    biceps: patientNumber(patient, "pliegue_biceps_mm"),
    subscapular: patientNumber(patient, "pliegue_subescapular_mm"),
    crest: patientNumber(patient, "pliegue_cresta_iliaca_mm"),
    supraespinal: patientNumber(patient, "pliegue_supraespinal_mm"),
    abdominal: patientNumber(patient, "pliegue_abdominal_mm"),
    thigh: patientNumber(patient, "pliegue_muslo_mm"),
    calf: patientNumber(patient, "pliegue_pantorrilla_mm"),
  };
  const values = Object.values(skinfolds).filter((value) => value > 0);
  const sum = (...items) => round(items.reduce((total, value) => total + value, 0), 1);
  const total = sum(...values);
  if (!total) {
    return {
      method: "sumatoria_pliegues",
      label: "Sumatoria de pliegues",
      complete: false,
      missing: ["pliegue_triceps_mm", "pliegue_subescapular_mm", "pliegue_supraespinal_mm"],
    };
  }
  const sum3Somatotype = sum(skinfolds.triceps, skinfolds.subscapular, skinfolds.supraespinal);
  const sum4Durnin = sum(skinfolds.triceps, skinfolds.biceps, skinfolds.subscapular, skinfolds.supraespinal);
  const sum6Yuhasz = sum(skinfolds.triceps, skinfolds.subscapular, skinfolds.supraespinal, skinfolds.abdominal, skinfolds.thigh, skinfolds.calf);
  return {
    method: "sumatoria_pliegues",
    label: "Sumatoria de pliegues",
    complete: true,
    totalSkinfolds: total,
    measuredSkinfoldCount: values.length,
    sum3Somatotype,
    sum4Durnin,
    sum6Yuhasz,
    summaryValue: `${total} mm`,
    detail: `${values.length} pliegues medidos. Suma 6 Yuhasz ${sum6Yuhasz} mm; suma 4 Durnin ${sum4Durnin} mm.`,
  };
}

function calculateYuhasz(patient) {
  const weight = patientNumber(patient, "peso_kg");
  const triceps = patientNumber(patient, "pliegue_triceps_mm");
  const subscapular = patientNumber(patient, "pliegue_subescapular_mm");
  const supraespinal = patientNumber(patient, "pliegue_supraespinal_mm");
  const abdominal = patientNumber(patient, "pliegue_abdominal_mm");
  const thigh = patientNumber(patient, "pliegue_muslo_mm");
  const calf = patientNumber(patient, "pliegue_pantorrilla_mm");
  const sum6 = triceps + subscapular + supraespinal + abdominal + thigh + calf;
  if (!sum6) return { method: "yuhasz", label: "Yuhasz", complete: false, sum6: 0 };
  const fatPercent = sexIsMale(patient)
    ? (sum6 * 0.1051) + 2.585
    : (sum6 * 0.1548) + 3.58;
  return {
    method: "yuhasz",
    label: "Yuhasz",
    complete: true,
    sum6: round(sum6, 1),
    fatPercent: round(fatPercent, 1),
    ...fatMassFromPercent(weight, fatPercent),
    formula: sexIsMale(patient) ? "sumatoria_6 * 0.1051 + 2.585" : "sumatoria_6 * 0.1548 + 3.58",
  };
}

function calculateDurninSiri(patient) {
  const weight = patientNumber(patient, "peso_kg");
  const triceps = patientNumber(patient, "pliegue_triceps_mm");
  const biceps = patientNumber(patient, "pliegue_biceps_mm");
  const subscapular = patientNumber(patient, "pliegue_subescapular_mm");
  const supraespinal = patientNumber(patient, "pliegue_supraespinal_mm");
  const sum4 = triceps + biceps + subscapular + supraespinal;
  if (!sum4) return { method: "durnin_siri", label: "Durnin + Siri", complete: false, sum4: 0 };
  const density = 1.1422 - (0.0544 * Math.log10(sum4));
  const fatPercent = ((4.95 / density) - 4.5) * 100;
  return {
    method: "durnin_siri",
    label: "Durnin + Siri",
    complete: true,
    sum4: round(sum4, 1),
    density: round(density, 4),
    fatPercent: round(fatPercent, 1),
    ...fatMassFromPercent(weight, fatPercent),
    formula: "DC = 1.1422 - 0.0544 * LOG10(sumatoria_4); Siri = ((4.95 / DC) - 4.5) * 100",
  };
}

function calculateRfm(patient) {
  const weight = patientNumber(patient, "peso_kg");
  const height = patientNumber(patient, "talla_cm");
  const waist = patientNumber(patient, "perimetro_cintura_cm");
  if (!height || !waist) return { method: "rfm", label: "Masa grasa relativa", complete: false };
  const fatPercent = sexIsMale(patient)
    ? 64 - (20 * height / waist)
    : 76 - (20 * height / waist);
  return {
    method: "rfm",
    label: "Masa grasa relativa",
    complete: true,
    fatPercent: round(fatPercent, 1),
    ...fatMassFromPercent(weight, fatPercent),
    formula: sexIsMale(patient) ? "64 - 20 * talla_cm / cintura_cm" : "76 - 20 * talla_cm / cintura_cm",
  };
}

function calculateFiveComponents(patient) {
  const required = [
    "peso_kg",
    "talla_cm",
    "estatura_sentado_cm",
    "pliegue_triceps_mm",
    "pliegue_subescapular_mm",
    "pliegue_supraespinal_mm",
    "pliegue_abdominal_mm",
    "pliegue_muslo_mm",
    "pliegue_pantorrilla_mm",
    "perimetro_cefalico_cm",
    "perimetro_brazo_relajado_cm",
    "perimetro_brazo_tenso_cm",
    "perimetro_antebrazo_cm",
    "perimetro_torax_cm",
    "perimetro_cintura_cm",
    "perimetro_muslo_superior_cm",
    "perimetro_pantorrilla_cm",
    "diametro_biacromial_cm",
    "diametro_biliocrestal_cm",
    "diametro_torax_transverso_cm",
    "diametro_torax_ap_cm",
    "diametro_humero_cm",
    "diametro_femur_cm",
  ];
  const missing = listMissing(patient, required);
  if (missing.length) {
    return {
      method: "cinco_componentes",
      label: "Cinco componentes",
      complete: false,
      missing,
    };
  }

  const weight = patientNumber(patient, "peso_kg");
  const height = patientNumber(patient, "talla_cm");
  const sittingHeight = patientNumber(patient, "estatura_sentado_cm");
  const triceps = patientNumber(patient, "pliegue_triceps_mm");
  const subscapular = patientNumber(patient, "pliegue_subescapular_mm");
  const supraespinal = patientNumber(patient, "pliegue_supraespinal_mm");
  const abdominal = patientNumber(patient, "pliegue_abdominal_mm");
  const thighSkinfold = patientNumber(patient, "pliegue_muslo_mm");
  const calfSkinfold = patientNumber(patient, "pliegue_pantorrilla_mm");
  const cephalic = patientNumber(patient, "perimetro_cefalico_cm");
  const armRelaxed = patientNumber(patient, "perimetro_brazo_relajado_cm");
  const armTensed = patientNumber(patient, "perimetro_brazo_tenso_cm");
  const forearm = patientNumber(patient, "perimetro_antebrazo_cm");
  const thorax = patientNumber(patient, "perimetro_torax_cm");
  const waist = patientNumber(patient, "perimetro_cintura_cm");
  const thigh = patientNumber(patient, "perimetro_muslo_superior_cm");
  const calf = patientNumber(patient, "perimetro_pantorrilla_cm");
  const biacromial = patientNumber(patient, "diametro_biacromial_cm");
  const bicristal = patientNumber(patient, "diametro_biliocrestal_cm");
  const thoraxTransverse = patientNumber(patient, "diametro_torax_transverso_cm");
  const thoraxAp = patientNumber(patient, "diametro_torax_ap_cm");
  const humerus = patientNumber(patient, "diametro_humero_cm");
  const femur = patientNumber(patient, "diametro_femur_cm");

  const surfaceArea = 68.308 * (weight ** 0.425) * ((height ** 0.725) / 10000);
  const boneBodySum = biacromial + bicristal + (2 * humerus) + (2 * femur);
  const headBoneZ = (cephalic - 56) / 1.44;
  const bodyBoneZ = ((boneBodySum * (170.18 / height)) - 98.88) / 5.33;
  const headBoneMass = (headBoneZ * 0.18) + 1.2;
  const bodyBoneMass = ((bodyBoneZ * 1.34) + 6.7) / ((170.18 / height) ** 3);
  const tricepsCorrection = triceps / 10;
  const subscapularCorrection = subscapular / 10;
  const abdominalCorrection = abdominal / 10;
  const thighCorrection = thighSkinfold / 10;
  const calfCorrection = calfSkinfold / 10;
  const correctedThorax = thorax - (Math.PI * subscapularCorrection);
  const correctedArm = armRelaxed - (Math.PI * tricepsCorrection);
  const correctedThigh = thigh - (Math.PI * thighCorrection);
  const correctedCalf = calf - (Math.PI * calfCorrection);
  const muscularPerimeterSum = correctedArm + forearm + correctedThigh + correctedCalf + correctedThorax;
  const residualSum = thoraxAp + thoraxTransverse + (waist - (Math.PI * abdominalCorrection));
  const skinfoldSum6 = triceps + subscapular + supraespinal + abdominal + thighSkinfold + calfSkinfold;
  const adiposeZ = ((skinfoldSum6 * (170.18 / height)) - 116.41) / 34.79;
  const muscularZ = ((muscularPerimeterSum * (170.18 / height)) - 207.21) / 13.74;
  const residualZ = ((residualSum * (89.92 / sittingHeight)) - 109.35) / 7.08;
  const skinThickness = sexIsMale(patient) ? 2.07 : 1.96;

  const skinKg = surfaceArea * skinThickness * 1.05;
  const adiposeKg = ((adiposeZ * 5.85) + 25.6) / ((170.18 / height) ** 3);
  const boneKg = headBoneMass + bodyBoneMass;
  const residualKg = ((residualZ * 1.24) + 6.1) / ((89.92 / sittingHeight) ** 3);
  const muscleKg = ((muscularZ * 5.4) + 24.5) / ((170.18 / height) ** 3);
  const structuredWeight = skinKg + adiposeKg + boneKg + residualKg + muscleKg;
  const adjust = (value) => structuredWeight ? value * (weight / structuredWeight) : 0;
  const adjustedSkinKg = adjust(skinKg);
  const adjustedAdiposeKg = adjust(adiposeKg);
  const adjustedBoneKg = adjust(boneKg);
  const adjustedResidualKg = adjust(residualKg);
  const adjustedMuscleKg = adjust(muscleKg);
  const adjustedTotalKg = adjustedSkinKg + adjustedAdiposeKg + adjustedBoneKg + adjustedResidualKg + adjustedMuscleKg;
  const percentOfTotal = (value) => adjustedTotalKg ? (value * 100) / adjustedTotalKg : 0;

  return {
    method: "cinco_componentes",
    label: "Cinco componentes",
    complete: true,
    fatPercent: round(percentOfTotal(adjustedAdiposeKg), 1),
    fatKg: round(adjustedAdiposeKg, 2),
    leanKg: round(weight - adjustedAdiposeKg, 2),
    skinKg: round(adjustedSkinKg, 2),
    skinPercent: round(percentOfTotal(adjustedSkinKg), 1),
    adiposeKg: round(adjustedAdiposeKg, 2),
    adiposePercent: round(percentOfTotal(adjustedAdiposeKg), 1),
    boneKg: round(adjustedBoneKg, 2),
    bonePercent: round(percentOfTotal(adjustedBoneKg), 1),
    residualKg: round(adjustedResidualKg, 2),
    residualPercent: round(percentOfTotal(adjustedResidualKg), 1),
    muscleKg: round(adjustedMuscleKg, 2),
    musclePercent: round(percentOfTotal(adjustedMuscleKg), 1),
    totalKg: round(adjustedTotalKg, 2),
    structuredWeight: round(structuredWeight, 2),
    muscleBoneIndex: adjustedBoneKg ? round(adjustedMuscleKg / adjustedBoneKg, 2) : 0,
    adiposeMuscleIndex: adjustedMuscleKg ? round(adjustedAdiposeKg / adjustedMuscleKg, 2) : 0,
    skinfoldSum6: round(skinfoldSum6, 1),
    sourceRows: "Datos!E183:E215",
    formula: "Ross & Kerr 1988 segun formato Excel actualizado: piel, adiposa, osea, residual y muscular ajustadas al peso.",
  };
}

function classifyBmi(bmi) {
  if (!bmi) return "";
  if (bmi < 18.5) return "Bajo peso para la talla";
  if (bmi < 25) return "Normal";
  if (bmi < 30) return "Sobrepeso";
  if (bmi < 35) return "Obesidad tipo I";
  if (bmi < 40) return "Obesidad tipo II";
  return "Obesidad tipo III";
}

function classifySomatotype(endo, meso, ecto) {
  const values = [
    { key: "endo", label: "Endomorfo", value: endo },
    { key: "meso", label: "Mesomorfo", value: meso },
    { key: "ecto", label: "Ectomorfo", value: ecto },
  ].filter((item) => Number.isFinite(item.value));
  if (values.length < 3) return "";
  values.sort((a, b) => b.value - a.value);
  const [first, second] = values;
  if (Math.abs(first.value - second.value) < 0.8) return `${first.label}-${second.label}`;
  const modifierByKey = {
    endo: "endomorfo",
    meso: "mesomorfo",
    ecto: "ectomorfo",
  };
  if (first.key === "meso" && second.key === "endo") return "Meso endomorfo";
  if (first.key === "meso" && second.key === "ecto") return "Meso ectomorfo";
  if (first.key === "endo" && second.key === "meso") return "Endo mesomorfo";
  if (first.key === "endo" && second.key === "ecto") return "Endo ectomorfo";
  if (first.key === "ecto" && second.key === "meso") return "Ecto mesomorfo";
  if (first.key === "ecto" && second.key === "endo") return "Ecto endomorfo";
  return `${first.label} ${modifierByKey[second.key]}`;
}

function calculateSomatotype(patient) {
  const weight = patientNumber(patient, "peso_kg");
  const height = patientNumber(patient, "talla_cm");
  const triceps = patientNumber(patient, "pliegue_triceps_mm");
  const subscapular = patientNumber(patient, "pliegue_subescapular_mm");
  const supraespinal = patientNumber(patient, "pliegue_supraespinal_mm");
  const calfSkinfold = patientNumber(patient, "pliegue_pantorrilla_mm");
  const armTensed = patientNumber(patient, "perimetro_brazo_tenso_cm");
  const calf = patientNumber(patient, "perimetro_pantorrilla_cm");
  const humerus = patientNumber(patient, "diametro_humero_cm");
  const femur = patientNumber(patient, "diametro_femur_cm");
  if (!weight || !height) return { complete: false };

  const sum3 = triceps + subscapular + supraespinal;
  const correctedSum = sum3 && height ? (sum3 * 170.18) / height : 0;
  const endomorphy = correctedSum
    ? (-0.7182) + (0.1451 * correctedSum) - (0.00068 * correctedSum ** 2) + (0.0000014 * correctedSum ** 3)
    : 0;
  const ponderalIndex = height / (weight ** (1 / 3));
  const ectomorphy = ponderalIndex
    ? (ponderalIndex > 40.75 ? (0.732 * ponderalIndex) - 28.58 : (0.463 * ponderalIndex) - 17.63)
    : 0;
  const mesomorphy = humerus && femur && armTensed && calf
    ? (0.858 * humerus)
      + (0.601 * femur)
      + (0.188 * (armTensed - (triceps / 10)))
      + (0.161 * (calf - (calfSkinfold / 10)))
      - (0.131 * height)
      + 4.5
    : 0;

  const hasSomatotype = Boolean(endomorphy && mesomorphy && ectomorphy);
  return {
    complete: hasSomatotype,
    sum3: round(sum3, 1),
    correctedSum: round(correctedSum, 1),
    ponderalIndex: round(ponderalIndex, 2),
    endomorphy: round(endomorphy, 1),
    mesomorphy: round(mesomorphy, 1),
    ectomorphy: round(ectomorphy, 1),
    classification: hasSomatotype ? classifySomatotype(endomorphy, mesomorphy, ectomorphy) : "",
    x: hasSomatotype ? round(ectomorphy - endomorphy, 1) : 0,
    y: hasSomatotype ? round((2 * mesomorphy) - (ectomorphy + endomorphy), 1) : 0,
    formula: "X = ectomorfia - endomorfia; Y = 2 * mesomorfia - (ectomorfia + endomorfia)",
  };
}

function rawNumber(patient, fieldName) {
  const parsed = Number(patient?.[fieldName]);
  return Number.isFinite(parsed) ? parsed : 0;
}

function safePositive(value) {
  return Number.isFinite(value) && value > 0 ? value : 0;
}

function targetBase(method, label, complete, values = {}) {
  const kgAdiposeToLose = safePositive(values.kgAdiposeToLose);
  const kgMuscleToGain = safePositive(values.kgMuscleToGain);
  return {
    method,
    label,
    complete,
    ...values,
    kgAdiposeToLose: round(kgAdiposeToLose, 2),
    kgMuscleToGain: round(kgMuscleToGain, 2),
  };
}

function calculateTheoreticalWeight(patient) {
  const height = patientNumber(patient, "talla_cm");
  if (!height) return 0;
  const inchesOverFiveFeet = (height / 2.54) - 60;
  const value = sexIsMale(patient)
    ? 51.65 + (1.85 * inchesOverFiveFeet)
    : 48.67 + (1.65 * inchesOverFiveFeet);
  return round(value, 2);
}

function calculateYuhaszTarget(patient, yuhasz) {
  const expectedSum6 = patientNumber(patient, "meta_yuhasz_suma_6_pliegues_mm");
  const muscleChange = rawNumber(patient, "meta_yuhasz_cambio_muscular_kg");
  if (!expectedSum6 || !yuhasz?.complete || !yuhasz.leanKg) {
    return targetBase("yuhasz", "Metas Yuhasz", false, {
      expectedSum6,
      muscleChangeKg: muscleChange,
    });
  }
  const expectedFatPercent = sexIsMale(patient)
    ? (expectedSum6 * 0.1051) + 2.585
    : (expectedSum6 * 0.1548) + 3.58;
  const desiredWeight = yuhasz.leanKg / (1 - (expectedFatPercent / 100));
  const kgAdiposeToLose = patientNumber(patient, "peso_kg") - desiredWeight;
  const competitionWeight = desiredWeight + muscleChange;
  return targetBase("yuhasz", "Metas Yuhasz", true, {
    expectedSum6: round(expectedSum6, 1),
    expectedFatPercent: round(expectedFatPercent, 1),
    desiredWeightKg: round(desiredWeight, 2),
    competitionWeightKg: round(competitionWeight, 2),
    muscleChangeKg: round(muscleChange, 2),
    kgAdiposeToLose,
    kgMuscleToGain: muscleChange,
    formula: "Excel Datos filas 227-235: grasa esperada Yuhasz, peso deseado y cambio muscular.",
  });
}

function calculateDurninTarget(patient, durninSiri) {
  const expectedSum4 = patientNumber(patient, "meta_durnin_suma_4_pliegues_mm");
  const muscleChange = rawNumber(patient, "meta_durnin_cambio_muscular_kg");
  if (!expectedSum4 || !durninSiri?.complete || !durninSiri.leanKg) {
    return targetBase("durnin_siri", "Metas Durnin + Siri", false, {
      expectedSum4,
      muscleChangeKg: muscleChange,
    });
  }
  const density = 1.1422 - (0.0544 * Math.log10(expectedSum4));
  const expectedFatPercent = ((4.95 / density) - 4.5) * 100;
  const desiredWeight = durninSiri.leanKg / (1 - (expectedFatPercent / 100));
  const kgAdiposeToLose = patientNumber(patient, "peso_kg") - desiredWeight;
  const competitionWeight = desiredWeight + muscleChange;
  return targetBase("durnin_siri", "Metas Durnin + Siri", true, {
    expectedSum4: round(expectedSum4, 1),
    density: round(density, 4),
    expectedFatPercent: round(expectedFatPercent, 1),
    desiredWeightKg: round(desiredWeight, 2),
    competitionWeightKg: round(competitionWeight, 2),
    muscleChangeKg: round(muscleChange, 2),
    kgAdiposeToLose,
    kgMuscleToGain: muscleChange,
    formula: "Excel Datos filas 237-243: DC esperada Durnin, Siri, peso deseado y cambio muscular.",
  });
}

function calculateRfmTarget(patient, rfm) {
  const idealWaist = patientNumber(patient, "meta_rfm_cintura_ideal_cm");
  const height = patientNumber(patient, "talla_cm");
  const weight = patientNumber(patient, "peso_kg");
  if (!idealWaist || !height || !weight || !rfm?.complete) {
    return targetBase("rfm", "Metas masa grasa relativa", false, { idealWaist });
  }
  const expectedFatPercent = sexIsMale(patient)
    ? 64 - (20 * height / idealWaist)
    : 76 - (20 * height / idealWaist);
  const expectedFatKg = (expectedFatPercent * weight) / 100;
  const expectedLeanKg = weight - expectedFatKg;
  const kgAdiposeToLose = (rfm.fatKg || 0) - expectedFatKg;
  const kgMuscleToGain = expectedLeanKg - (rfm.leanKg || 0);
  const desiredWeight = weight - kgAdiposeToLose + safePositive(kgMuscleToGain);
  return targetBase("rfm", "Metas masa grasa relativa", true, {
    idealWaist: round(idealWaist, 1),
    expectedFatPercent: round(expectedFatPercent, 1),
    expectedFatKg: round(expectedFatKg, 2),
    expectedLeanKg: round(expectedLeanKg, 2),
    desiredWeightKg: round(desiredWeight, 2),
    competitionWeightKg: round(desiredWeight, 2),
    kgAdiposeToLose,
    kgMuscleToGain,
    formula: "Excel Datos filas 244-250: cintura ideal, RFM ideal, grasa y masa libre objetivo.",
  });
}

function calculateFiveComponentTarget(patient, fiveComponents) {
  const expectedSum6 = patientNumber(patient, "meta_5c_suma_pliegues_ideal_mm");
  const targetImo = patientNumber(patient, "meta_5c_objetivo_imo") || fiveComponents?.muscleBoneIndex || 0;
  const height = patientNumber(patient, "talla_cm");
  const weight = patientNumber(patient, "peso_kg");
  if (!expectedSum6 || !targetImo || !height || !weight || !fiveComponents?.complete) {
    return targetBase("cinco_componentes", "Metas cinco componentes", false, {
      expectedSum6,
      targetImo,
    });
  }
  const heightScale = 170.18 / height;
  const adiposityIndex = ((expectedSum6 * heightScale) - 116.41) / 34.79;
  const expectedAdiposeKg = ((adiposityIndex * 5.85) + 25.6) / (heightScale ** 3);
  const kgAdiposeToLose = (fiveComponents.adiposeKg || 0) - expectedAdiposeKg;
  const expectedMuscleKg = (fiveComponents.boneKg || 0) * targetImo;
  const kgMuscleToGain = expectedMuscleKg - (fiveComponents.muscleKg || 0);
  const competitionWeight = weight - kgAdiposeToLose + safePositive(kgMuscleToGain);
  return targetBase("cinco_componentes", "Metas cinco componentes", true, {
    expectedSum6: round(expectedSum6, 1),
    targetImo: round(targetImo, 2),
    expectedAdiposeKg: round(expectedAdiposeKg, 2),
    expectedMuscleKg: round(expectedMuscleKg, 2),
    desiredWeightKg: round(competitionWeight, 2),
    competitionWeightKg: round(competitionWeight, 2),
    kgAdiposeToLose,
    kgMuscleToGain,
    formula: "Excel Datos filas 252-259: pliegues ideales, masa adiposa objetivo, IMO y PDC.",
  });
}

function calculateAnthropometricTargets(patient, compositions) {
  const targets = {
    yuhasz: calculateYuhaszTarget(patient, compositions.yuhasz),
    durnin_siri: calculateDurninTarget(patient, compositions.durninSiri),
    rfm: calculateRfmTarget(patient, compositions.rfm),
    cinco_componentes: calculateFiveComponentTarget(patient, compositions.fiveComponents),
  };
  const selectedKey = patient?.metodo_antropometria === "sumatoria_pliegues"
    ? "yuhasz"
    : patient?.metodo_antropometria || "yuhasz";
  return {
    ...targets,
    selected: targets[selectedKey] || targets.yuhasz,
  };
}

function chooseBasicFatComposition(patient, yuhasz, durninSiri) {
  if (patient?.metodo_antropometria === "durnin_siri") return durninSiri;
  if (patient?.metodo_antropometria === "yuhasz" || patient?.metodo_antropometria === "sumatoria_pliegues") return yuhasz;
  return yuhasz?.complete ? yuhasz : durninSiri;
}

function chooseLeanMass(patient, compositions) {
  const requested = String(patient?.fuente_masa_libre_grasa || "rfm");
  const candidates = {
    rfm: compositions.rfm,
    durnin_siri: compositions.durninSiri,
    cinco_componentes: compositions.fiveComponents,
  };
  const selected = candidates[requested]?.leanKg ? candidates[requested] : Object.values(candidates).find((item) => item?.leanKg);
  return {
    value: selected?.leanKg ? round(selected.leanKg, 2) : 0,
    source: selected?.method || requested,
    label: selected?.label || leanMassSourceOptions.find((item) => item.value === requested)?.label || "Masa libre de grasa",
  };
}

function calculateDerivedBasics(patient, compositions, targets) {
  const fatComposition = chooseBasicFatComposition(patient, compositions.yuhasz, compositions.durninSiri);
  const leanMass = chooseLeanMass(patient, compositions);
  const targetWeight = targets.selected?.competitionWeightKg || targets.selected?.desiredWeightKg || 0;
  return {
    idealWeightKg: round(targetWeight || calculateTheoreticalWeight(patient), 2),
    idealWeightSource: targetWeight ? `metas_${targets.selected.method}` : "peso_teorico_talla_genero",
    objectiveWeightKg: patientNumber(patient, "peso_objetivo_kg"),
    fatPercent: fatComposition?.fatPercent ? round(fatComposition.fatPercent, 1) : 0,
    fatPercentSource: fatComposition?.method || "",
    leanMass,
  };
}

function selectPrimaryComposition(patient, methods) {
  const preferred = patient?.metodo_antropometria || "yuhasz";
  const byMethod = new Map(methods.map((method) => [method.method, method]));
  const selected = byMethod.get(preferred);
  if (selected) return selected;
  return methods.find((method) => method.method !== "sumatoria_pliegues" && method.complete && (method.fatPercent || method.adiposePercent)) || null;
}

export function calculateAnthropometry(patient) {
  const weight = patientNumber(patient, "peso_kg");
  const height = patientNumber(patient, "talla_cm");
  const bmi = weight && height ? weight / ((height / 100) ** 2) : 0;
  const yuhasz = calculateYuhasz(patient);
  const durninSiri = calculateDurninSiri(patient);
  const rfm = calculateRfm(patient);
  const fiveComponents = calculateFiveComponents(patient);
  const skinfoldSums = calculateSkinfoldSums(patient);
  const somatotype = calculateSomatotype(patient);
  const primaryComposition = selectPrimaryComposition(patient, [skinfoldSums, fiveComponents, yuhasz, durninSiri, rfm]);
  const targets = calculateAnthropometricTargets(patient, { yuhasz, durninSiri, rfm, fiveComponents });
  const derivedBasics = calculateDerivedBasics(patient, { yuhasz, durninSiri, rfm, fiveComponents }, targets);

  return {
    ageYears: resolvePatientAge(patient),
    bmi: round(bmi, 1),
    bmiClassification: classifyBmi(bmi),
    waistToHeight: height ? round(patientNumber(patient, "perimetro_cintura_cm") / height, 2) : 0,
    activeSections: getActiveAnthropometrySections(patient),
    yuhasz,
    durninSiri,
    rfm,
    fiveComponents,
    skinfoldSums,
    primaryComposition,
    somatotype,
    targets,
    derivedBasics,
    source: "Formato actualizado antropometria programa dietas.xlsx",
  };
}
